<template>
    <section class="inline welcome large bg-brand veterans-welcome">
        <div class="grid gap-3 fixed fixed-max-sm middle xs-grid-cols-1 sm-grid-cols-2 ">
            <div class="img">
                <img :src="glb.cdnUrl + 'vimages/veterans-hero.webp'" alt="Welcome Home Movoto" fetchpriority="auto"/>
            </div>
            <div class="flex vertical large top center">
                <h1 class="f1">Veteran Homebuyers:</h1>
                <div>
                    <ul>
                        <li>No down payment (0%)</li>
                        <li>No private mortgage insurance</li>
                        <li>Low closings costs</li>
                        <li>Quick closing times</li>
                    </ul>
                </div>
                <div class="grid xs-grid-cols-1">
                    <button type="button" class="btn secondary regular" @click="openHotlead" style="width: fit-content;" >Find a Veterans Real Estate Agent</button>
                    <button type="button" class="btn secondary regular" @click="show3rdPartyForm('veteranshub1', 'veteranshub1', $event)" style="width: fit-content;">Prequalify for a 0% Down VA Loan</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script src="./veterans-welcome.js"></script>

<style lang="scss">
@use "./veterans-welcome.scss" as *;
</style>
